import React, { useState } from "react";
import Cropper from "react-easy-crop";
import { useLanguage } from "@/contexts/LanguageContext.jsx";
import { getCroppedImage } from "@/utils/getCroppedImage";

export default function CoverCropModal({ src, onCancel, onConfirm, aspect = 3 / 1 }) {
  const { t } = useLanguage();
  const [crop, setCrop] = React.useState({ x: 0, y: 0 });
  const [zoom, setZoom] = React.useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = React.useState(null);

  function onCropComplete(_croppedArea, croppedPixels) {
    setCroppedAreaPixels(croppedPixels);
  }

  return (
    <div className="fixed inset-0 z-[320] flex items-center justify-center bg-black/60 px-4">
      <div className="w-[92vw] max-w-[520px] overflow-hidden rounded-[16px] border border-[rgba(var(--clr-outline-variant),0.9)] bg-[rgb(var(--clr-surface-cont-highest))] shadow-[var(--elev-4)]">
        <div className="relative h-[220px] bg-black">
          <Cropper
            image={src}
            crop={crop}
            zoom={zoom}
            aspect={aspect}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
          />
        </div>

        <div className="px-4 py-3 space-y-3">
          <input
            type="range"
            min={1}
            max={3}
            step={0.1}
            value={zoom}
            onChange={(e) => setZoom(Number(e.target.value))}
            className="w-full"
          />

          <div className="flex justify-end gap-2">
            <button
              type="button"
              className="inline-flex h-11 items-center justify-center rounded-[12px] border border-[rgba(var(--clr-outline-variant),0.9)] bg-[rgb(var(--clr-surface))] px-4 text-label-medium text-on-surface transition hover:bg-[rgba(var(--clr-on-surface),0.03)]"
              onClick={onCancel}
            >
              {t("common.cancel", "Cancel")}
            </button>

            <button
              type="button"
              className="inline-flex h-11 items-center justify-center rounded-[12px] bg-[rgb(var(--afrimed-primary))] px-4 text-label-medium text-[rgb(var(--afrimed-on-primary))] transition hover:opacity-95"
              onClick={async () => {
                const blob = await getCroppedImage(src, croppedAreaPixels);
                onConfirm?.(blob);
              }}
            >
              {t("common.savePhoto", "Save photo")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
